import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumns3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="columns-3, layout, third" maskId="round-filled-radius-0-stroke-1.5-IconColumns3"><path d="M8 21H3.75C3.33579 21 3 20.6642 3 20.25V3.75C3 3.33579 3.33579 3 3.75 3H8V21Z" fill="currentColor"/><path d="M14.5 3V21H9.5V3H14.5Z" fill="currentColor"/><path d="M20.25 3C20.6642 3 21 3.33579 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21H16V3H20.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumns3;
